export function toDisposable(teardown) {
    return { [Symbol.dispose]: teardown };
}
